var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "header__dropdown-container" }, [
    _c("div", { staticClass: "header__dropdown-container-inner" }, [
      _c(
        "div",
        {
          staticClass:
            "header__dropdown-container-inner-links-small-images-container",
          class: [
            {
              "header__dropdown-container-inner-links--single-column":
                _vm.block.image_1 && _vm.block.image_2 && _vm.block.image_3
            }
          ]
        },
        [
          _c(
            "div",
            {
              staticClass:
                "header__dropdown-container-inner-featured-menu-links-container"
            },
            [
              _vm.block.featured_link_list_active
                ? _c(
                    "div",
                    { staticClass: "header__dropdown-side-list" },
                    _vm._l(_vm.block.featured_link_list, function(link, index) {
                      return _c(
                        "ul",
                        { staticClass: "header__dropdown-list" },
                        [
                          _vm.block.title
                            ? _c("li", [
                                _c(
                                  "a",
                                  {
                                    staticClass:
                                      "header__dropdown-list-title header__dropdown-featured-link link link--primary",
                                    attrs: { href: link.url }
                                  },
                                  [_vm._v(_vm._s(link.title))]
                                )
                              ])
                            : _vm._e()
                        ]
                      )
                    }),
                    0
                  )
                : _vm._e(),
              _c(
                "div",
                {
                  staticClass:
                    "header__dropdown-lists-container header__dropdown-list-menu-links-main-container"
                },
                _vm._l(_vm.block.link_list, function(link, index) {
                  return _c(
                    "ul",
                    {
                      staticClass:
                        "header__dropdown-list header__dropdown-list-menu-links-container"
                    },
                    [
                      _c(
                        "li",
                        {
                          staticClass:
                            "header__dropdown-list-links-image-container"
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "header-dropdown-list-links-container"
                            },
                            [
                              _c(
                                "a",
                                {
                                  staticClass:
                                    "header__dropdown-list-title link link--primary",
                                  class: {
                                    "header__dropdown-list-title--margin-bottom-none": !(
                                      link.children && link.children.length > 0
                                    )
                                  },
                                  attrs: { href: link.url }
                                },
                                [_vm._v(_vm._s(link.title))]
                              ),
                              _vm._l(link.children, function(
                                child_link,
                                index
                              ) {
                                return _c("ul", [
                                  _c(
                                    "li",
                                    {
                                      staticClass: "header__dropdown-list-item"
                                    },
                                    [
                                      _c(
                                        "a",
                                        {
                                          staticClass:
                                            "header__dropdown-link link link--primary",
                                          attrs: { href: child_link.url }
                                        },
                                        [_vm._v(_vm._s(child_link.title))]
                                      )
                                    ]
                                  )
                                ])
                              })
                            ],
                            2
                          )
                        ]
                      )
                    ]
                  )
                }),
                0
              )
            ]
          ),
          _c(
            "div",
            { staticClass: "header__dropdown-small-images-container" },
            [
              _vm.block.image_1
                ? _c(
                    "div",
                    { staticClass: "header__dropdown-image-outer-container" },
                    [
                      _vm.block.image_1_url
                        ? _c(
                            "a",
                            {
                              staticClass:
                                "header__dropdown-image-outer-content-container",
                              attrs: { href: _vm.block.image_1_url },
                              on: {
                                mouseover: function($event) {
                                  _vm.hover01 = true
                                },
                                mouseleave: function($event) {
                                  _vm.hover01 = false
                                }
                              }
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "header__dropdown-image-container zoom-transition"
                                },
                                [
                                  _c("img", {
                                    staticClass: "header__dropdown-image",
                                    attrs: {
                                      src: _vm.imageSize(
                                        _vm.block.image_1,
                                        "300x"
                                      ),
                                      alt: _vm.block.image_1_text,
                                      loading: "lazy"
                                    }
                                  })
                                ]
                              ),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "header-menu-image-title-container"
                                },
                                [
                                  _vm.block.image_1_text
                                    ? _c(
                                        "p",
                                        {
                                          staticClass:
                                            "header-menu-image-title link link--primary",
                                          class: { hoverimage: _vm.hover01 }
                                        },
                                        [_vm._v(_vm._s(_vm.block.image_1_text))]
                                      )
                                    : _vm._e()
                                ]
                              )
                            ]
                          )
                        : _c(
                            "div",
                            {
                              staticClass:
                                "header__dropdown-image-outer-content-container"
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "header__dropdown-image-container zoom-transition"
                                },
                                [
                                  _c("img", {
                                    staticClass: "header__dropdown-image",
                                    attrs: {
                                      src: _vm.imageSize(
                                        _vm.block.image_1,
                                        "300x"
                                      ),
                                      alt: _vm.block.image_1_text,
                                      loading: "lazy"
                                    }
                                  })
                                ]
                              ),
                              _vm.block.image_1_text
                                ? _c(
                                    "p",
                                    { staticClass: "header-menu-image-title" },
                                    [_vm._v(_vm._s(_vm.block.image_1_text))]
                                  )
                                : _vm._e()
                            ]
                          )
                    ]
                  )
                : _vm._e(),
              _vm.block.image_2
                ? _c(
                    "div",
                    { staticClass: "header__dropdown-image-outer-container" },
                    [
                      _vm.block.image_2_url
                        ? _c(
                            "a",
                            {
                              staticClass:
                                "header__dropdown-image-outer-content-container",
                              attrs: { href: _vm.block.image_2_url },
                              on: {
                                mouseover: function($event) {
                                  _vm.hover02 = true
                                },
                                mouseleave: function($event) {
                                  _vm.hover02 = false
                                }
                              }
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "header__dropdown-image-container zoom-transition"
                                },
                                [
                                  _c("img", {
                                    staticClass: "header__dropdown-image",
                                    attrs: {
                                      src: _vm.imageSize(
                                        _vm.block.image_2,
                                        "300x"
                                      ),
                                      alt: _vm.block.image_2_text,
                                      loading: "lazy"
                                    }
                                  })
                                ]
                              ),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "header-menu-image-title-container"
                                },
                                [
                                  _vm.block.image_2_text
                                    ? _c(
                                        "p",
                                        {
                                          staticClass:
                                            "header-menu-image-title link link--primary",
                                          class: { hoverimage: _vm.hover02 }
                                        },
                                        [_vm._v(_vm._s(_vm.block.image_2_text))]
                                      )
                                    : _vm._e()
                                ]
                              )
                            ]
                          )
                        : _c(
                            "div",
                            {
                              staticClass:
                                "header__dropdown-image-outer-content-container"
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "header__dropdown-image-container zoom-transition"
                                },
                                [
                                  _c("img", {
                                    staticClass: "header__dropdown-image",
                                    attrs: {
                                      src: _vm.imageSize(
                                        _vm.block.image_2,
                                        "300x"
                                      ),
                                      alt: _vm.block.image_2_text,
                                      loading: "lazy"
                                    }
                                  })
                                ]
                              ),
                              _vm.block.image_2_text
                                ? _c(
                                    "p",
                                    { staticClass: "header-menu-image-title" },
                                    [_vm._v(_vm._s(_vm.block.image_2_text))]
                                  )
                                : _vm._e()
                            ]
                          )
                    ]
                  )
                : _vm._e(),
              _vm.block.image_3
                ? _c(
                    "div",
                    { staticClass: "header__dropdown-image-outer-container" },
                    [
                      _vm.block.image_3_url
                        ? _c(
                            "a",
                            {
                              staticClass:
                                "header__dropdown-image-outer-content-container",
                              attrs: { href: _vm.block.image_3_url },
                              on: {
                                mouseover: function($event) {
                                  _vm.hover03 = true
                                },
                                mouseleave: function($event) {
                                  _vm.hover03 = false
                                }
                              }
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "header__dropdown-image-container zoom-transition"
                                },
                                [
                                  _c("img", {
                                    staticClass: "header__dropdown-image",
                                    attrs: {
                                      src: _vm.imageSize(
                                        _vm.block.image_3,
                                        "300x"
                                      ),
                                      alt: _vm.block.image_3_text,
                                      loading: "lazy"
                                    }
                                  })
                                ]
                              ),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "header-menu-image-title-container"
                                },
                                [
                                  _vm.block.image_3_text
                                    ? _c(
                                        "p",
                                        {
                                          staticClass:
                                            "header-menu-image-title link link--primary",
                                          class: { hoverimage: _vm.hover03 }
                                        },
                                        [_vm._v(_vm._s(_vm.block.image_3_text))]
                                      )
                                    : _vm._e()
                                ]
                              )
                            ]
                          )
                        : _c(
                            "div",
                            {
                              staticClass:
                                "header__dropdown-image-outer-content-container"
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "header__dropdown-image-container zoom-transition"
                                },
                                [
                                  _c("img", {
                                    staticClass: "header__dropdown-image",
                                    attrs: {
                                      src: _vm.imageSize(
                                        _vm.block.image_3,
                                        "300x"
                                      ),
                                      alt: _vm.block.image_3_text,
                                      loading: "lazy"
                                    }
                                  })
                                ]
                              ),
                              _vm.block.image_3_text
                                ? _c(
                                    "p",
                                    { staticClass: "header-menu-image-title" },
                                    [_vm._v(_vm._s(_vm.block.image_3_text))]
                                  )
                                : _vm._e()
                            ]
                          )
                    ]
                  )
                : _vm._e()
            ]
          )
        ]
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }